import { User } from 'types';

export interface AuthState {
  user?: User;
  error?: Error;
  path?: string;
  isLoggedIn: boolean;
  isTokenUpdated?: boolean;
}

export interface AuthLogout {
  error?: Error;
  byUser?: boolean;
  // WEB PUSH: only the Sign out confirm switches this device's push off
  // (not an expired session, nor another tab's sign-out).
  signOut?: boolean;
}

export const types = {
  auth: 'auth/login',
  logout: 'auth/logout',
};
